export const iventisLogo = "https://cdn.iventis.co.uk/assets/iventis_logo_new.png";
